import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import CategoriesTable from "./table";
import ListGroup from "../common/listGroup";
import Pagination from "../common/pagination";
import {
  getCategoriesByProgramId,
  deleteCategory,
} from "../../services/categoryService";
import { getPrograms } from "../../services/programService";
import { paginate } from "../../utils/paginate";
import _ from "lodash";
import SearchBox from "../searchBox";

class Categories extends Component {
  state = {
    categories: [],
    programs: [],
    currentPage: 1,
    pageSize: 4,
    searchQuery: "",
    selectedProgram: null,
    sortColumn: { path: "name", order: "asc" },
  };

  async componentDidMount() {
    const { data } = await getPrograms();
    const programs = [{ _id: "", name: "All Programs" }, ...data.programs];
    console.log(programs);

    let categories = [];
    for (let program of programs) {
      if (program._id !== "") {
        const data = await getCategoriesByProgramId(program._id);
        categories = categories.concat(data.data.userCategories);
      }
    }
    this.setState({ categories, programs });
  }

  handleDelete = async (category) => {
    const originalCategories = this.state.categories;
    const categories = originalCategories.filter((m) => m._id !== category._id);
    this.setState({ categories });

    try {
      await deleteCategory(category._id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This category has already been deleted.");

      this.setState({ categories: originalCategories });
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleProgramSelect = (program) => {
    this.setState({
      selectedProgram: program,
      searchQuery: "",
      currentPage: 1,
    });
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedProgram: null,
      currentPage: 1,
    });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      selectedProgram,
      searchQuery,
      categories: allCategories,
    } = this.state;

    let filtered = allCategories;
    console.log(filtered);
    if (searchQuery)
      filtered = allCategories.filter((m) =>
        m.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    else if (selectedProgram && selectedProgram._id)
      filtered = allCategories.filter(
        (m) => m.program._id === selectedProgram._id
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const categories = paginate(sorted, currentPage, pageSize);
    console.log(categories);
    return { totalCount: filtered.length, data: categories };
  };

  render() {
    const { length: count } = this.state.categories;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;

    const { totalCount, data: categories } = this.getPagedData();

    return (
      <div className="row">
        <div className="col-3">
          <ListGroup
            items={this.state.programs}
            selectedItem={this.state.selectedProgram}
            onItemSelect={this.handleProgramSelect}
          />
        </div>
        <div className="col">
          <Link
            to="/categories/new"
            className="btn btn-primary float-right"
            style={{ marginBottom: 20 }}
          >
            Nueva Categoría
          </Link>

          {count > 0 && (
            <React.Fragment>
              <p>Showing {totalCount} categories in the database.</p>
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <CategoriesTable
                categories={categories}
                sortColumn={sortColumn}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
              />
              <Pagination
                itemsCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={this.handlePageChange}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default Categories;
